export interface DossierAbandonSuccess {
  type: 'success';
  abandonmentComment: string;
}

export interface DossierAbandonCancel {
  type: 'cancel';
}

export interface DossierAbandonLater {
  type: 'later';
  finishLaterComment: string;
}

export type DossierAbandonOutputData =
  | DossierAbandonSuccess
  | DossierAbandonLater
  | DossierAbandonCancel;
